module.exports = __webpack_public_path__ + "img/ModularWallV3.1fddde9a.jpg";